"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ArticleBase = _interopRequireDefault(require("./ArticleBase"));

var _ArticleHead = _interopRequireDefault(require("./ArticleHead"));

var _ArticleBody = _interopRequireDefault(require("./ArticleBody"));

var _ArticleSection = _interopRequireDefault(require("./ArticleSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Article = ({
  formData,
  formContext
}) => {
  const language = formContext.currentLocale || formContext.defaultLocale || formData.locale;
  const content = formData && formData.content;
  const title = content.title,
        leadtext = content.leadtext,
        headerImage = content.headerImage,
        sections = content.sections;
  return _react.default.createElement(_ArticleBase.default, null, _react.default.createElement(_ArticleHead.default, {
    language: language,
    title: title,
    leadtext: leadtext,
    media: headerImage && [headerImage]
  }), _react.default.createElement(_ArticleBody.default, null, sections && sections.map((section, index) => _react.default.createElement(_ArticleSection.default, _extends({}, section, {
    language: language
  })))));
};

Article.defaultProps = {
  formData: {},
  formContext: {}
};
var _default = Article;
exports.default = _default;
module.exports = exports.default;